import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';
import SparklesIcon from '../../../assets/images/icons/SparklesIcon';

const DEFAULT_SUGGESTIONS = [
  { icon: faList, text: 'Quali prodotti sono disponibili' },
];

function NoMessagePlaceHolder({
  message = 'Fai una domanda per iniziare la conversazione.',
  suggestions = DEFAULT_SUGGESTIONS,
  onSuggestionSelect,
}) {
  return (
    <div className="text-center mx-auto py-3" style={{ maxWidth: '420px' }}>
      <div
        className="bg-success rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
        style={{ width: '56px', height: '56px' }}
      >
        <SparklesIcon width={24} height={24} />
      </div>
      <h6 className="fw-bold mb-1">Ciao, sono l&apos;assistente AI Greenia</h6>
      <p className="text-muted small mb-3">{message}</p>
      <div className="d-flex flex-column gap-2 text-start">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion.text}
            type="button"
            className="btn btn-outline-secondary border rounded-3 d-flex align-items-center gap-2 py-2 px-3"
            onClick={() => onSuggestionSelect && onSuggestionSelect(suggestion.text)}
          >
            <FontAwesomeIcon icon={suggestion.icon} className="text-success" />
            {suggestion.text}
          </button>
        ))}
      </div>
    </div>
  );
}

export default NoMessagePlaceHolder;
